import { ErrorHandler, Injectable, inject } from '@angular/core';
import { ApplicationInsightsLoggingService } from '../logging.service';
import { SharedModuleConfig } from '../config/shared-module-config';

@Injectable({
  providedIn: 'root',
})
export class MdefErrorHandlerService implements ErrorHandler {
  private loggingService = inject(ApplicationInsightsLoggingService);
  private sharedModuleConfig = inject(SharedModuleConfig);

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleError(error: any): void {
    // if (!this.production) {
    console.error(error);
    // }
    this.loggingService.logException(error);
  }
}
